import { getCurrentBrowserTimezone } from "~/common/utils/dateUtils";
import { formatNullable, getCsrfValue } from "~/common/utils/ApiHelper";
import { type LineItem } from "~/features/cart/cart/models/CartData";
import { getHybrisProductCode } from "~/utils/cartHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";

interface UpdateQuoteApiItem {
  productCode: string;
  packageSize?: number;
  packageCode: string;
  quantity: number;
  comment?: string;
  internalComment?: string;
  selectedDeliveryDate?: string;
  primaryWarehouseCode: string;
  offerPrice?: number;
  targetPrice?: number;
  minimumSellingPrice?: number;
  recommendedSellingPrice?: number;
  priceReference?: string;
  orderEntryNumber: number;
  packageEntryNumber: number;
  packageEntryPk: number;
  orderEntryPk: number;
}

interface UpdateQuoteItem {
  productCode: string;
  packageSize?: number;
  packageCode: string;
  quantity: number;
  comment?: string;
  internalComment?: string;
  selectedDeliveryDate: Date | null;
  primaryWarehouseCode: string;
  offerPrice?: number;
  targetPrice?: number;
  /**
   * Needs to be per piece or BE freaks out
   * TODO: Update BE to accept per {unitPrice} pieces
   */
  msp?: number;
  /**
   * Needs to be per piece or BE freaks out
   * TODO: Update BE to accept per {unitPrice} pieces
   */
  rsp?: number;
  priceReference: string;
  orderEntryNumber: number;
  packageEntryNumber: number;
  packageEntryPk: number;
  orderEntryPk: number;
}

function transform(item: UpdateQuoteItem): UpdateQuoteApiItem {
  const rdd = item.selectedDeliveryDate;
  const { msp, rsp, ...baseItem } = item;

  return {
    ...baseItem,
    selectedDeliveryDate: formatNullable(rdd),
    // TEMP CHANGE - add new line character to internal comment
    internalComment: item.internalComment ? item.internalComment + "\n" : "",
    minimumSellingPrice: msp,
    recommendedSellingPrice: rsp,
  };
}

export function fromLineItem(data: LineItem): UpdateQuoteItem {
  return {
    productCode: getHybrisProductCode(data.productCode),
    packageSize: data.packSize,
    packageCode: data.packCode,
    quantity: data.quantity,
    comment: data.comment,
    selectedDeliveryDate: data.deliveryDate,
    // estimatedDeliveryDate: (data.edd && data.edd.type === 'estimate') ? data.edd.date : undefined,
    primaryWarehouseCode: data.primaryWarehouseCode,
    priceReference: data.priceReference,

    msp: data.msp ? data.msp.value : undefined,
    rsp: data.rsp ? data.rsp.value : undefined,
    internalComment: data.internalComment,
    offerPrice: data.offerPrice ? data.offerPrice.value : undefined,
    targetPrice: data.targetPrice ? data.targetPrice.value : undefined,

    orderEntryNumber: data.entryNumber!,
    packageEntryNumber: data.entryNumber!,
    orderEntryPk: data.cartEntryPk,
    packageEntryPk: data.pk,
  };
}

const bulkUpdateApiUrl = resolveApiUrl("/quote/update/bulk");

export function sendBulkUpdate(items: UpdateQuoteItem[]) {
  const body = {
    items: items.map(transform),
    userTimeZone: getCurrentBrowserTimezone(),
  };

  return performUpdate(bulkUpdateApiUrl, JSON.stringify(body));
}

const updateApiUrl = resolveApiUrl("/quote/update");

export function sendUpdate(data: UpdateQuoteItem) {
  const body = transform(data);

  return performUpdate(updateApiUrl, JSON.stringify(body));
}

function performUpdate(url: string, body: string) {
  return fetch(url, {
    body: body,
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
  }).then((result) => {
    window.SCHA.updateMinicart?.();
    return result;
  });
}
